import { ChangeDetectorRef, Component, forwardRef, Input, OnChanges, OnDestroy, OnInit } from '@angular/core';
import { NG_VALUE_ACCESSOR, NG_VALIDATORS, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer } from '@angular/platform-browser';

import { Subscription } from 'rxjs';
import * as _ from 'lodash';
import { NameFormValues } from 'src/app/model';
import { ServicecallService, SubmitButtonClickService } from 'src/app/services';

@Component({
  selector: 'app-profile-form',
  templateUrl: './profile-form.component.html',
  styleUrls: ['./profile-form.component.css'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => ProfileFormComponent),
      multi: true
    },
    {
      provide: NG_VALIDATORS,
      useExisting: forwardRef(() => ProfileFormComponent),
      multi: true
    }
  ]
})
export class ProfileFormComponent implements OnDestroy, OnInit, OnChanges {

  @Input() data: any;
  @Input() existingData: any;
  @Input() image: any;
  @Input() existingClicked: any;
  @Input() view: any;
  submitted: boolean = false;
  form: FormGroup;
  isImageSaved: boolean = false;
  imageError!: any;
  imgURL: any = null;

  private _subscriptions: Subscription[] = [];
  private _sasUrl: any = null;
  private _thumbnail: any = null;
  private _tradeImg: any;
  private _cardImageBase64!: any;
  private _valueChangesSubscription: Subscription;
  private _updateTradeImageSubscription: Subscription;
  private _getSubmitButtonClickSubscription: Subscription;
  private _getDisableFormSuccessSubscription: Subscription;
  private _getEnableFormSuccessSubscription: Subscription;
  private _getSubmitButtonSuccessSubscription: Subscription;

  constructor(
    private _fb: FormBuilder,
    private _submitButtonClick: SubmitButtonClickService,
    private _submitButtonSuccess: SubmitButtonClickService,
    private _service: ServicecallService,
    private _cd: ChangeDetectorRef,
    private _domSanitizer: DomSanitizer,
    private _disableForm: SubmitButtonClickService,
    private _enableForm: SubmitButtonClickService
  ) {
    this.form = this._fb.group({
      image: [],
      name: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]],
      description: ['', [Validators.required, Validators.pattern(/^[^\s]+(\s+[^\s]+)*$/)]]
    });
    this._subscriptions.push(
      this._valueChangesSubscription = this.form.valueChanges.subscribe(value => {
        this.onChange(value);
        this.onTouched();
      })
    );
    this._getSubmitButtonClickSubscription = this._submitButtonClick.getSubmitButtonClick().subscribe((res: any) => {
      this.submitted = true;
    });
    this._getDisableFormSuccessSubscription = this._disableForm.getDisableFormSuccess().subscribe((res: any) => {
      this.form.disable();
    });
    this._getEnableFormSuccessSubscription = this._enableForm.getEnableFormSuccess().subscribe((res: any) => {
      this.form.enable();
      this.image = null;
    });
    this._getSubmitButtonSuccessSubscription = this._submitButtonSuccess.getSubmitButtonSuccess().subscribe((res: any) => {
      this.imageError = null;
      this.errorMessage = null;
      this.imgURL = null;
    });
  }

  get value(): NameFormValues {
    return this.form.value;
  }

  get nameFormValues() {
    return this.form.controls;
  }

  set value(value: NameFormValues) {
    this.form.setValue(value);
    this.onChange(value);
    this.onTouched();
  }

  ngOnInit(): void {
    if (this.existingClicked) {
      this.form.disable();
    }
  }

  ngOnChanges() {
    if (this.data) {
      this._imageConvert(this.data?.tradeicon?.image);
    } else if (this.existingData) {
      this._imageConvert(this.existingData?.tradeicon?.image);
    }
  }

  ngOnDestroy() {
    this._subscriptions.forEach(s => s.unsubscribe());
    this._valueChangesSubscription?.unsubscribe();
    this._updateTradeImageSubscription?.unsubscribe();
    this._getDisableFormSuccessSubscription?.unsubscribe();
    this._getEnableFormSuccessSubscription?.unsubscribe();
    this._getSubmitButtonSuccessSubscription?.unsubscribe();
  }

  onChange: any = () => { };
  onTouched: any = () => { };

  registerOnChange(fn: any) {
    this.onChange = fn;
  }

  writeValue(value: NameFormValues | null) {
    if (value) {
      this.value = value;
    }

    if (value === null) {
      this.form.reset();
    }
  }

  registerOnTouched(fn: any) {
    this.onTouched = fn;
  }


  getStyle() {
    if (this.imgURL) {
      return "position-relative  profile-circle list-image-outer"
    } else {
      return "position-relative icon-upload profile-circle list-image-outer"
    }
  }

  onImageSelected(event: any): any | void {
    this._sasUrl = null;
    this._thumbnail = null;
    this.imageError = null;
    this.errorMessage = null;
    let img: File;
    let reader = new FileReader();
    reader.readAsDataURL(event.target.files[0]);
    // reader.onload = () => {
    //   this.imgURL = reader.result;
    // };
    img = event.target.files[0];
    this._tradeImg = img;
    this._cd.markForCheck();
    if (event.target.files && event.target.files[0]) {
      // Size Filter Bytes
      const max_size = 100000;
      const allowed_types = ['image/svg+xml'];
      const max_height = 50;
      const max_width = 50;
      if (event.target.files[0].size > max_size) {
        this.imageError = 'Maximum size allowed is ' + max_size / 1000 + 'Kb';
        this.imgURL = null;
        return false;
      }
      if (!_.includes(allowed_types, event.target.files[0].type)) {
        this.imageError = 'Only SVG Images are allowed';
        this.imgURL = null;
        return false;
      }
      reader.onload = (e: any) => {
        const image = new Image();
        this.imgURL = reader.result;
        image.src = e.target.result;
        image.onload = (rs: any): any | void => {
          const img_height = rs.currentTarget['height'];
          const img_width = rs.currentTarget['width'];
          if (img_height > max_height && img_width > max_width) {
            this.imageError = 'Maximum dimensions allowed ' + max_height + 'px' + '*' + max_width + 'px';
            this.imgURL = null;
            return false;
          } else {
            const imgBase64Path = e.target.result;
            this._cardImageBase64 = imgBase64Path;
            if (this.data) {
              this._updateTradeImage(this._tradeImg, null, null, 'tenant', this.data['tradeName'], null, false);
            }
            else {
              this._updateTradeImage(this._tradeImg, null, null, 'tenant', null, null, false);
            }
            this.isImageSaved = true;
          }
        };
      };
    }
  }
  deleteImage() {
    if (this.data) {
      this._updateTradeImage(null, null, this._imageId, null, null, this.data['_id'], true);
    }
    else {
      this._updateTradeImage(null, null, this._imageId, null, null, null, true);
    }
    // based on erormessages
    this.isImageSaved = false;
    this._cardImageBase64 = null;
    this.imageError = null;
    this._imageId = null;
    this._imageBase64 = null;
    this.errorMessage = 'TradeImage is required'
  }

  errorMessage: any;

  private _imageId: any = null;
  private _imageBase64: any = null;
  private _updateTradeImage(img: any, type: any, imageId: any, scope: any, tradeName: any, tradeId: any, del?: any) {
    this._updateTradeImageSubscription = this._service.updateTradeImage(img, type, imageId, scope, tradeName, tradeId).subscribe((res: any) => {
      if (res['status']) {
        if (del) {
          this._imageBase64 = null;
          this.imgURL = null;
          this._imageId = null;
        }
        if (res['response']['_id']) {
          this._imageId = res['response']['_id'];
          this.form.value.image = res['response']['_id'];
          this.form.patchValue({ image: res['response']['_id'] })
        }
        if (res['response']['image']) {
          this._imageBase64 = res['response']['image'];
          let i = this._getBlob(this._imageBase64);
          let selectedFile: any = i;
          const reader = new FileReader();
          reader.onload = (e) => {
            var lines = reader.result!.toString().split('\n');
            for (var line = 0; line < lines.length; line++) {

            }
            let replacedBlob = new Blob(lines, { type: 'image/svg+xml' });
            let applicationZip = new File([replacedBlob], "Mock.svg", { type: 'image/svg+xml' });
            var fileURL = URL.createObjectURL(applicationZip);
            this.imgURL = this._domSanitizer.bypassSecurityTrustUrl(fileURL);
          }
          reader.readAsText(selectedFile);
        }
        else {
          this._imageId = null;
        }

      } else {

      }
    })
  }

  private _getBlob(base64: any) {
    var byteString = atob(base64);
    var ab = new ArrayBuffer(byteString.length);
    var ia = new Uint8Array(ab);
    for (var i = 0; i < byteString.length; i++) {
      ia[i] = byteString.charCodeAt(i);
    }
    return new Blob([ab], { type: 'image/svg' });
  }


  private _imageConvert(imageBase64: any) {
    if (imageBase64) {
      let i = this._getBlob(imageBase64);
      let selectedFile: any = i;
      const reader = new FileReader();
      reader.onload = (e: any) => {
        let lines = reader.result!.toString().split('\n');
        for (let line = 0; line < lines.length; line++) {
        }
        let replacedBlob = new Blob(lines, { type: 'image/svg+xml' });
        let applicationZip = new File([replacedBlob], "Mock.svg", { type: 'image/svg+xml' });
        let fileURL = URL.createObjectURL(applicationZip);
        this.imgURL = this._domSanitizer.bypassSecurityTrustUrl(fileURL);
      }
      reader.readAsText(selectedFile);
    }
  }
  // communicate the inner form validation to the parent form
  validate(_: FormControl) {
    return this.form.valid ? null : { name: { valid: false } };
  }


}
